import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import { generalizedHistoryUrl } from 'SharedDir/backend/endpoints/generalized-history';
import {
  GeneralizedHistoryBare,
  GeneralizedHistoryItem,
  makeGeneralizedHistoryId,
} from 'SharedDir/declarations/generalized-history';
import { PaginationParams } from 'SharedDir/declarations/pagination';
import { ReportTaskBare } from 'SharedDir/declarations/report-tasks';

import SimpleApi from './simpleApi';

export default class GeneralizedHistoryApiClass extends SimpleApi<
  GeneralizedHistoryItem,
  never,
  never,
  GeneralizedHistoryItem
> {
  constructor() {
    super(generalizedHistoryUrl);
  }

  async store(): Promise<never> {
    throw new Error('Method is not allowed.');
  }

  async update(): Promise<never> {
    throw new Error('Method is not allowed.');
  }

  async delete(): Promise<never> {
    throw new Error('Method is not allowed.');
  }

  public async getPaginated<Extra extends object>(params: PaginationParams<Extra>) {
    const response = await super.getPaginated<Extra>(params);

    return {
      ...response,
      data: response.data.map((item) => this.withSyntheticId(item as unknown as GeneralizedHistoryBare)),
    };
  }

  public async exportInBackground<Extra extends object>(
    params: Omit<PaginationParams<object>, 'rowsPerPage' | 'page'> & Extra
  ): Promise<ReportTaskBare> {
    const { data } = (await http({
      method: 'GET',
      url: `${this.url}/export`,
      params: { ...params, rowsPerPage: 0, page: 1 },
    })) as AxiosResponse<ReportTaskBare>;

    return data;
  }

  private withSyntheticId(item: GeneralizedHistoryBare): GeneralizedHistoryItem {
    return {
      ...item,
      id: makeGeneralizedHistoryId(item),
    };
  }
}
